import React, { useCallback, useMemo, createContext, useState } from 'react'
import * as Sc from './ModalContext.styles'

export const ModalContext = createContext()

// ONLY PREPARED FOR FULL SCREEN RIGHT NOW
const ModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({
    content: null,
    prevModalProps: null,
    show: false,
    zIndex: 999,
  })

  const closeModal = useCallback(() => {
    setModalProps((modalProps) => {
      return {
        ...modalProps,
        content: modalProps.prevModalProps?.content ?? null,
        prevModalProps: null,
        show: modalProps.prevModalProps != null,
        zIndex: modalProps.prevModalProps?.zIndex ?? 999,
      }
    })
  }, [setModalProps])

  const openModal = useCallback(
    ({ content, zIndex, savePrevModalContext }) => {
      setModalProps((modalProps) => {
        return {
          ...modalProps,
          content,
          prevModalProps: savePrevModalContext ? modalProps : null,
          show: true,
          zIndex: zIndex || modalProps.zIndex,
        }
      })
    },
    [setModalProps]
  )

  // memoize the full context value
  const contextValue = useMemo(
    () => ({
      closeModal,
      isOpen: modalProps.show,
      openModal,
    }),
    [closeModal, openModal, modalProps]
  )

  return (
    <ModalContext.Provider value={contextValue}>
      {modalProps.show && (
        <Sc.ModalContainer data-testid='modal-container' zIndex={modalProps.zIndex}>
          {modalProps.content}
        </Sc.ModalContainer>
      )}
      {children}
    </ModalContext.Provider>
  )
}

const useModal = () => {
  const context = React.useContext(ModalContext)
  if (context === undefined) {
    throw new Error('useModal must be used within a Provider')
  }

  return context
}

export { ModalProvider, useModal }
